<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.66797 10.0013C1.66797 6.07293 1.66797 4.10874 2.88836 2.88836C4.10874 1.66797 6.07293 1.66797 10.0013 1.66797C13.9296 1.66797 15.8939 1.66797 17.1142 2.88836C18.3346 4.10874 18.3346 6.07293 18.3346 10.0013C18.3346 13.9296 18.3346 15.8939 17.1142 17.1142C15.8939 18.3346 13.9296 18.3346 10.0013 18.3346C6.07293 18.3346 4.10874 18.3346 2.88836 17.1142C1.66797 15.8939 1.66797 13.9296 1.66797 10.0013ZM14.168 11.043C14.4285 11.043 14.6617 11.2046 14.7531 11.4486C14.8446 11.6925 14.7752 11.9676 14.579 12.1389L11.7144 14.6389C11.4543 14.8658 11.0595 14.839 10.8325 14.5789C10.6056 14.3189 10.6324 13.9241 10.8925 13.6971L12.5013 12.293H5.83463C5.48946 12.293 5.20963 12.0131 5.20963 11.668C5.20963 11.3228 5.48946 11.043 5.83463 11.043H14.168ZM9.17013 5.42368C9.39705 5.68374 9.37022 6.07856 9.11022 6.30553L7.5013 7.70963H14.168C14.5131 7.70963 14.793 7.98946 14.793 8.33463C14.793 8.6798 14.5131 8.95963 14.168 8.95963H5.83463C5.57411 8.95963 5.34091 8.79805 5.24943 8.55405C5.15795 8.31014 5.22738 8.03505 5.42368 7.86374L8.28826 5.36374C8.5483 5.13678 8.94313 5.16361 9.17013 5.42368Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TransactionsIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>